import React, { useState } from 'react'

import TournamentUnit from './TournamentUnit'

import Importer from './Importer'

import { Tournament } from '../types'
import Header from 'components/header'
import { Container, Button } from 'semantic-ui-react'
import { useNavigate } from 'react-router-dom'


const MyTournamentIndex = () => {
    const navigate = useNavigate();
    const [, SetImportedContent] = useState('');

    const getTournamentKeys = (): string[] => {
        var localTournaments: string[] = [];
        const keys = Object.keys(localStorage)
        keys.forEach((k) => {
            if (k.split('#')[0] === 'Tournament') {
                localTournaments.push(k);
            }
        })
        return localTournaments;
    }

    const renderTours = () => {
        const tourKeys = getTournamentKeys();
        if (tourKeys.length > 0) {
            return (
                tourKeys.map((key) => <TournamentUnit tournamentKey={key} />)
            )
        } else {
            return (
                <div style={{margin: '3em 0px'}}>
                    <h3>You have no tournaments</h3>
                    <p>Create a new tournament or import</p>
                </div>
            )
        }
    }

    const importTournament = (fileName: string, tournamentRawData: string): void => {

        try {
            const decodedTournament = JSON.parse(tournamentRawData + '') as Tournament;
            localStorage.setItem('' + decodedTournament.Id, JSON.stringify(decodedTournament));
            SetImportedContent(tournamentRawData)
            renderTours();

        } catch (e) {
            alert("Could not import tournament")
        }


    }

    return (
        <div className='melee-wrapper'>
            <Container className='regularText' style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Header
                    helmet='Tournaments'
                    hideDivider
                    rightMenu={ 
                    <button 
                        className="melee-inline-button"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                    }
                />
                <div style={{ margin: '2em 0px' }}>
                    {renderTours()}
                    <Button 
                        label 
                        icon='plus' 
                        onClick={() => navigate('/create')}
                        content='Create' 
                        basic className='melee'
                    />
                    <Importer
                        importTournament={importTournament}
                    />
                </div>
            </Container>
        </div>
    )

}

export default MyTournamentIndex;